import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

export async function listarTags() {
  const res = await api.get("/news/tags/all");
  return res.data;
}

export async function crearTag(payload) {
  const res = await apiAuth.post("/news/tags", payload);
  return res.data;
}

export async function editarTag(id, payload) {
  const res = await apiAuth.put(`/news/tags/${id}`, payload);
  return res.data;
}

export async function eliminarTag(id) {
  const res = await apiAuth.delete(`/news/tags/${id}`);
  return res.data;
}
